<template>
	<el-container>
		<el-aside :width="Collapse?'65px' : '200px'" style="background-color: white;box-shadow: 2px 0 6px rgba(0, 21, 41, .35)">
			<SideMenu :Collapse="Collapse" @CollapseMenu="getCollapseMenu"></SideMenu>
		</el-aside>
		<el-container>
			<div class="tui" title="退出登录" @click="logout">
				<img src="../assets/tui.png" alt="">
			</div>
			<el-main>
				<Tabs></Tabs>
				<div style="margin: 0 15px; ">
					<router-view/>
				</div>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
import SideMenu from "./inc/SideMenu";
import Tabs from "./inc/Tabs";

export default {
	name: "Home",
	components: {
		SideMenu, Tabs
	},
	data() {
		return {
			Collapse: false,
			userInfo: {
				id: "",
				unitid: "",
				username: "",
				nickname: "",
				avatar: "",
				unitname: ""
			}
		}
	},
	created() {
		// this.getUserInfo()
	},
	methods: {
		getUserInfo() {
			this.$axios.get("/sys/userInfo").then(res => {
				this.userInfo = res.data.data
			})
		},
		getCollapseMenu() {
			this.Collapse = !this.Collapse
		},
		logout() {
			this.$confirm('确定退出系统吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				localStorage.clear()
				sessionStorage.clear()
				this.$store.commit("resetState")
				this.$router.push("/login")
			})

			// this.$axios.post("/logout").then(res => {
			// 	localStorage.clear()
			// 	sessionStorage.clear()

			// 	this.$store.commit("resetState")

			// 	this.$router.push("/login")
			// })
		}
	}
}
</script>

<style scoped>
.el-container {
	padding: 0;
	margin: 0;
	height: 100%;
}

.header-avatar {
	float: right;
	width: 130px;
	display: flex;
	justify-content: space-around;
	align-items: center;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-header {
	background-color: #11A983;
	color: #333;
	text-align: center;
	line-height: 60px;
}

.el-aside {
	background-color: #D3DCE6;
	color: #333;
	line-height: 200px;
}

.el-main {
	color: #333;
	padding: 0;
}

a {
	text-decoration: none;
}

.tui {
	width: 50px;
	height: 50px;
	position: fixed;
	right: 30px;
	top: 20px;
	background: #e7e5e5;
	z-index: 1999;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	box-shadow: 2px 0 6px rgba(0, 21, 41, .35);
	cursor: pointer;
}
.tui:hover {
	transform: scale(1.2);
}
.tui img {
	width: 30px;
	height: 30px;
}
</style>